import { Link } from 'react-router-dom';
import type { TrainingSession } from '@/mocks/actualites';

type SessionsTableProps = {
  sessions: TrainingSession[];
};

const statusMeta: Record<TrainingSession['status'], { label: string; className: string }> = {
  ouvert: {
    label: 'Inscriptions ouvertes',
    className: 'bg-accent-100 text-accent-900',
  },
  'dernieres-places': {
    label: 'Dernières places',
    className: 'bg-primary-100 text-primary-900',
  },
  complet: {
    label: 'Complet',
    className: 'bg-secondary-200 text-secondary-900',
  },
};

export default function SessionsTable({ sessions }: SessionsTableProps) {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="hidden grid-cols-[1.5fr_1.3fr_1fr_1fr_auto] gap-4 border-b border-background-200 bg-background-100 px-5 py-3 lg:grid">
        {['Parcours', 'Dates de session', 'Durée', 'Disponibilité', 'Inscription'].map((head) => (
          <span key={head} className="label-mono text-foreground-500">
            {head}
          </span>
        ))}
      </div>

      {sessions.map((session) => {
        const status = statusMeta[session.status];
        const isFull = session.status === 'complet';
        return (
          <div
            key={session.slug}
            className="grid gap-3 border-b border-background-200 px-5 py-5 last:border-b-0 lg:grid-cols-[1.5fr_1.3fr_1fr_1fr_auto] lg:items-center lg:gap-4"
          >
            <div className="min-w-0">
              <p className="font-heading text-lg font-semibold uppercase leading-tight text-foreground-950">
                {session.program}
              </p>
              <p className="mt-0.5 font-label text-[10px] uppercase tracking-[0.14em] text-foreground-400">
                Atelier de Logbaba
              </p>
            </div>

            <p className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-calendar-line text-primary-500 lg:hidden" />
              {session.dates}
            </p>

            <p className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-time-line text-primary-500 lg:hidden" />
              {session.duration}
            </p>

            <div className="flex items-center gap-3">
              <span
                className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.1em] ${status.className}`}
              >
                {status.label}
              </span>
              <span className="text-xs text-foreground-500">{session.seats}</span>
            </div>

            <Link
              to="/formation#inscription"
              className={`flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.1em] transition-colors duration-300 ${
                isFull
                  ? 'border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-700'
                  : 'bg-primary-500 text-background-50 hover:bg-primary-600'
              }`}
            >
              {isFull ? 'Liste d’attente' : 'S’inscrire'}
              <i className="ri-arrow-right-up-line text-sm" />
            </Link>
          </div>
        );
      })}
    </div>
  );
}